import '../organizations/parts/organization-ancestors-bread-crumbs';
import '../organizations/parts/organization-bin-count-header';
import '../organizations/parts/organization-dropdown';
import '../organizations/props/organization-name';
import './parts/add-bin-button';
import './parts/bin-list';
import './parts/combine-bins-button';
import './parts/export-bins-button';
import '../../parcels/add-bin-dialog';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';

class BinListView extends LitEntity {
  static get properties() {
    return {
      binsHref: { type: String, attribute: false },
      millHref: { type: String, attribute: false },
      sort: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-wrap: wrap;
      }
      .button-container {
        display: flex;
        margin-right: calc(var(--root-margin) / 2);
      }
      .button-container .title-button {
        margin: .5em .25em .5em 0;
      }
      .title {
        display: flex;
        margin-top: var(--root-margin);
      }
      .title h1 {
        align-content: center;
        margin: 0 0 0 var(--root-margin);
      }
      organization-ancestors-bread-crumbs {
        --last-crumb-overflow: visible;
        margin-left: var(--root-margin);
      }
    `];
  }

  render() {
    return html`
      <div class="title-container">
        <div class="title">
          <h1>
            <organization-bin-count-header .href="${this.href}"></organization-bin-count-header>
            <span>Bins</span>
          </h1>
        </div>

        <div class="button-container">
          <add-bin-dialog href="${this.href}"></add-bin-dialog>

          <combine-bins-button
            .href="${this.href}"
            class="title-button"
          ></combine-bins-button>

          <export-bins-button
            .href="${this.href}"
            class="title-button"
          ></export-bins-button>
        </div>
      </div>

      <organization-ancestors-bread-crumbs
        .href="${this.href}"
        linkPath="/bins/list"
        ancestorMinIndex="0"
      >
        <organization-dropdown dest="/bins/list" .href="${this.href}"></organization-dropdown>
      </organization-ancestors-bread-crumbs>

      <bin-list href="${this.binsHref || ''}"></bin-list>
      <lit-entity href="${this.millHref || ''}" @update="${this.onMillUpdate}"></lit-entity>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.millHref = this.getHref('https://api.binsentry.com/rel/account');
    if (!this.millsHref) {
      this.updateBinsHref();
    }
  }

  onMillUpdate({ detail }) {
    const features = detail.entity?.properties?.features;
    this.sort = features?.legacyBinList ? 'name' : 'emptyAt';
    this.updateBinsHref();
  }

  updateBinsHref() {
    const binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
    const url = new URL(binsHref);
    url.searchParams.set('sort', this.sort || '');
    url.searchParams.set('limit', '60');
    this.binsHref = url.href;
  }

  onAddBin() {
    entityStore.invalidateHref(this.binsHref);
  }
}

window.customElements.define('bin-list-view', BinListView);
